import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  TextInput,
  Row,
  Column,
  Select,
  SelectItem,
  PasswordInput,
  ButtonSet,
} from "carbon-components-react";
import { SaveModel24 } from "@carbon/icons-react";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import http from "../../http-common";
import {
  userSchema,
  roleRules,
  passwordRules,
} from "../../services/SchemaService";
import { AuthContext } from "../../contexts/AuthContext";
import { useContext } from "react";
import useGet from "../../hooks/useGet";


const UserProfilePage = () => {

  const { data: roles } = useGet("/lookup/user-roles");
  const [showPassword, setShowPassword] = useState(false);
  const [user, setUser] = useState({});

  const authContext = useContext(AuthContext);

  const getSchema = () => {
    if (showPassword === true) {
      return userSchema.concat(passwordRules);
    } else {
      return userSchema;
    }
  };

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm({ resolver: yupResolver(getSchema()), mode: "onBlur" });

  const onSubmit = async (data) => {
    try {
      await http.put('/users', data);
      toast.success("Dados actualizados com sucesso!");
      setShowPassword(false);
    } catch (error) {
      toast.error(error.response?.data.message);
    }
  };

  const handleChangeRole = async (e) => {
  };

  const changePassword = async () => {
    setShowPassword(true);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await http.get('/users/' + authContext.user.username);
        const fields = [
          "id",
          "username",
          "firstName",
          "lastName",
          "email",
          "roleCode",
          "roleDescription"
        ];
        fields.forEach((field) => setValue(field, user[field]));
        setUser(result.data);
      } catch (error) {
        toast.error(error.response?.data.message);
      }
    };

    fetchData();

  }, []);

  useEffect(() => {
    reset(user);
  }, [user]);

  return (
    <div className="card">
      <div className="card-header">
        <h3 className="card-title">Meu Perfil</h3>
      </div>
      <div className="card-body">
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row>
            <Column sm={6} md={6} lg={6}>
              <TextInput
                id="firstName"
                labelText="Nome"
                maxLength={64}
                {...register("firstName")}
              />
              <p className="field-error">{errors.firstName?.message}</p>
            </Column>
            <Column sm={6} md={6} lg={6}>
              <TextInput
                id="lastName"
                labelText="Apelido"
                maxLength={64}
                {...register("lastName")}
              />
              <p className="field-error">{errors.lastName?.message}</p>
            </Column>
          </Row>
          <Row>
            <Column sm={12} md={6} lg={6}>
              <TextInput
                id="username"
                labelText="Número de telefone"
                {...register("username")}
                maxLength={9}
              />
              <p className="field-error">{errors.username?.message}</p>
            </Column>
            <Column sm={12} md={6} lg={6}>
              <TextInput id="email" labelText="Email" {...register("email")} />
              <p className="field-error">{errors.email?.message}</p>
            </Column>
          </Row>
            <Row>
              <Column sm={2} md={6} lg={6}>
                <Select
                  id="roleCode"
                  labelText="Perfil"
                  {...register("roleCode")}
                  onChange={handleChangeRole}
                  disabled={true}
                >
                  <SelectItem text="" value="" />
                  {roles.map((p) => (
                    <SelectItem
                      text={p.description}
                      value={p.code}
                      key={p.code}
                    />
                  ))}
                </Select>

                <p className="field-error">{errors.roleCode?.message}</p>
              </Column>
            </Row>
          {showPassword && (
            <Row>
              <Column sm={12} md={6} lg={6}>
                <PasswordInput
                  id="password"
                  labelText="Nova Senha"
                  maxLength={16}
                  {...register("password")}
                />
                <p className="field-error">{errors.password?.message}</p>
              </Column>
              <Column sm={12} md={6} lg={6}>
                <PasswordInput
                  id="passwordConfirm"
                  labelText="Confirmação da Senha"
                  maxLength={16}
                  {...register("passwordConfirm")}
                />
                <p className="field-error">{errors.passwordConfirm?.message}</p>
              </Column>
            </Row>
          )}
          <Row className="mt-2">
            <Column sm={12} md={12} lg={12} className="form-buttons">
              <ButtonSet>
                <Button
                  type="submit"
                  renderIcon={SaveModel24}
                  iconDescription="Save"
                >
                  Salvar
                </Button>
              </ButtonSet>

              {!showPassword && (
                <ButtonSet>
                  <Button
                    type="button"
                    onClick={changePassword}
                    className="emprega-bg-orange"
                  >
                    Alterar Senha
                  </Button>
                </ButtonSet>
              )}
            </Column>
          </Row>
        </Form>
      </div>
    </div>
  );
};

export default UserProfilePage;
